export default __webpack_public_path__ + "static/media/desktop-image-hero-3.05fd679a.jpg";